import { render, staticRenderFns } from "./PerfisAcessoForm.vue?vue&type=template&id=6c19f4da"
import script from "./PerfisAcessoForm.vue?vue&type=script&lang=js"
export * from "./PerfisAcessoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports